import Page from '@/global/util/Page'
import axios from 'axios'
import { BASE_URL } from '@/global/util/constants'
const OPERATION_LOG_SEARCH_MENU = 'OPERATION_LOG_SEARCH_MENU' //操作日志下拉菜单
const OPERATION_LOG_TABLE_DATA = 'OPERATION_LOG_TABLE_DATA' // 操作日志表格
const state = {
  operationLog: {
    page: new Page(),
    searchMenu: [],
    curSearch: ''
  }
}
const getters = {
  operationLog: state => state.operationLog
}
const actions = {
  async getSearchMenu({ state, commit }, { platform } = {}) {
    let result = await axios.get(`${BASE_URL}/interface/etcd/item/${ platform !== 'admin' ? 'operate_type_all' : 'operate_type' }`)
    commit(OPERATION_LOG_SEARCH_MENU, { result: result.data })
  },
  async getListData(
    { state, commit },
    { platform, params, page = state.operationLog.page.currentPage, perpage = state.operationLog.page.pageSize } = {}
  ) {
    let result = await axios.get(`${BASE_URL}/${platform}/tools/operatelog`, { params: { ...params, page, perpage } })
    commit(OPERATION_LOG_TABLE_DATA, { result: result.data })
  }
}
const mutations = {
  [OPERATION_LOG_SEARCH_MENU](state, { result }) {
    state.operationLog.searchMenu = result.data
    state.operationLog.curSearch = result.data ? result.data[0].value : ''
  },
  [OPERATION_LOG_TABLE_DATA](state, { result }) {
    state.operationLog.page.setPageData(
      {
        header: result.data.header,
        data: result.data.list,
        total: result.data.count
      },
      false
    )
  }
}

export default { state, getters, actions, mutations }
